export default __webpack_public_path__ + "static/Lato-Black-e5c10b5f2dd0f93e72d3d4c91b84b1e1.ttf";